.root {
  position: relative;
  display: inline-flex;
}

.menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: var(
    --chartv2-surface-raised,
    var(--surface-raised, var(--background-default, #fff))
  );
  border: 1px solid
    var(--chartv2-axis-line, var(--border-soft, rgba(0, 0, 0, 12%)));
  border-radius: 6px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 18%);
  padding: 4px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-width: 100%;
}

.item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1;
  color: var(--chartv2-foreground, var(--text-default, #202020));
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: inherit;
  width: 100%;
  text-align: left;
  box-sizing: border-box;
  font-weight: 500;
  white-space: nowrap;
}

.item:hover,
.item.focused {
  background: var(--chartv2-chip-hover, rgba(0, 0, 0, 6%));
}

.item.active {
  background: var(--chartv2-chip-active, rgba(0, 0, 0, 10%));
}

.item.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.item.separated {
  margin-top: 4px;
  padding-top: 10px;
  border-top: 1px solid
    var(--chartv2-axis-line, var(--border-soft, rgba(0, 0, 0, 10%)));
  border-radius: 0 0 4px 4px;
}
